import "./index.css";

const ErrorMessage = ({message, sub_message}) => {
	return (
		<div className="bdo">
			<div className="container9">
				<h1 className="error_head">-</h1>
				<div className="circle">
					<div className="cir2"></div>
				</div>

				<h1 className="h error_head">-</h1>
			</div>
			<center>
				<p className="error_name">{message}</p>
				<p className="error_name">{sub_message}</p>
			</center>
		</div>
	);
};

export default ErrorMessage;
